import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
// import { components } from 'react-select'
// import { travelBrandsService } from '../../_services/TravelBrands.service'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
);

const gender = [
  {label: 'مرد', value: 0},
  {label: 'زن' , value: 1}
]

class GenderSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      defaultValue: ''
    };
  }

  handleChange = e =>{
    this.props.onChange(e.value);
  }

  render() {
    const customStyles = {
      menu: (provided, state) => ({
        ...provided,
        margin: 0,
        padding: 0,
      }),
      menuList: (provided, state) => ({
        ...provided,
        margin: 0,
        padding: 0,
      }),
      option: (provided, state) => ({
        ...provided,
        padding: 10,
      }),
      dropdownIndicator: (provided, state) => ({
        ...provided,
        color: '#6d6d6d',
      }),
      control: (provided) => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#fff',
        borderRadius: 7,
        height: 40,
        boxShadow: 'none',
        paddingRight: '12',
        border: 'thin solid #b4b4b4',
        // marginBottom: 15
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),

    }
    const { loading } = this.state;
    const { disabled, required } = this.props;

    return (
      <div>
        {!loading &&
          <Select
            isDisabled={disabled}
            placeholder=""
            styles={customStyles}
            options={gender}
            onChange={this.handleChange}
            value={this.props.defaultValue}
            className={required ? "select required" : "select"}
            />
        }
      </div>
    );
  }
}
export default GenderSelect;
